@if (isInCall() || pendingInvitation()) {
  <div
    [@modalAnimation]="callStore.isModalHidden() ? 'hidden' : 'visible'"
    appResizable
    appDraggable
    class="call-modal theme-light-locked"
    [class.call-modal--fullscreen]="modal().isFullscreen"
    [style.left.px]="modal().isFullscreen ? null : modal().x"
    [style.top.px]="modal().isFullscreen ? null : modal().y"
    [style.width.px]="modal().isFullscreen ? null : modal().width"
    [style.height.px]="modal().isFullscreen ? null : modal().height"
    role="dialog"
    aria-label="Cuộc gọi"
    aria-modal="true"
    (resized)="onResize($event)"
    (dragged)="onDrag($event)"
    (dblclick)="toggleFullscreen()"
    [disabled]="modal().isFullscreen"
  >
    <!-- ── Title bar ── -->
    <div class="titlebar">
      <div class="titlebar-left">
        <!-- Fullscreen -->
        <button
          class="titlebar-btn titlebar-btn--full"
          (click)="toggleFullscreen()"
          [title]="modal().isFullscreen ? 'Thoát toàn màn hình' : 'Toàn màn hình'"
          aria-label="Fullscreen"
        >
          <app-icon [name]="modal().isFullscreen ? 'call/minimize' : 'call/maximize'" [size]="32" />
        </button>

        <!-- PiP -->
        <button
          class="titlebar-btn titlebar-btn--pip"
          [class.hidden]="this.pendingInvitation() || this.callState() !== CALL_STATE.CONNECTED"
          (click)="togglePip()"
          [title]="pipService.isOpen() ? 'Đóng PiP' : 'Picture-in-Picture'"
          aria-label="PiP"
        >
          <app-icon name="call/pip-icon" [size]="32" />
        </button>
      </div>

      <!-- Close -->
      <button
        class="titlebar-btn titlebar-btn--close"
        title="Đóng"
        aria-label="Đóng"
        (click)="handleCloseBtn()"
      >
        <app-icon name="call/x-icon" [size]="32" />
      </button>
    </div>

    <div
      class="bg-img relative h-full w-full flex flex-col overflow-y-auto pip-area"
      #pipAreaRef
      [class.bg-call-video]="isVideoCall() || isAnyScreenSharing()"
      [style.backgroundImage]="backgroundImage()"
      [style.backgroundColor]="backgroundColor()"
    >
      @if (hasValidAvatar()) {
        <img
          [src]="displayParticipant()!.avatar!"
          (error)="avatarBgError.set(true)"
          (load)="avatarBgError.set(false)"
          class="absolute w-0 h-0 opacity-0 pointer-events-none"
          alt=""
        />
      }
      <app-icon
        name="call/call-bg-shapes"
        [size]="971"
        [wSize]="1439"
        class="call-bg-shapes-icon"
        [class.!hidden]="!shapesColor() || isVideoCall()"
        [style.color]="shapesColor() || undefined"
      />
      <div
        class="absolute inset-0 bg-black/30 backdrop-blur-2xl"
        [class.hidden]="shapesColor() || isVideoCall()"
      ></div>

      <!-- Hiển thị Active Call -->
      @if (isInCall()) {
        <app-call-active
          class="absolute inset-0 z-10"
          [isFullscreen]="modal().isFullscreen"
          (closeModalEvt)="handleClose()"
        ></app-call-active>
      }

      <!-- Hiển thị Lời mời (Overlay lên trên nếu đang có Active Call) -->
      @if (pendingInvitation()) {
        <app-call-invitation
          class="absolute inset-0 z-20 transition-all duration-300"
          [invitation]="pendingInvitation()!"
          [participants]="pendingInvitation()!.invitees"
          [isWaiting]="isWaiting()"
          [isInMeeting]="isInMeeting()"
          (acceptEvt)="acceptCall($event)"
          (rejectEvt)="rejectCall($event)"
          (rejectTimeoutEvt)="rejectCallTimeout()"
        >
        </app-call-invitation>
      }
    </div>

    @if (pipService.isOpen()) {
      <div class="pip-note">
        <span class="pip-note__title">Đang trong hình trong hình</span>
      </div>
    }
  </div>
}
